import React, {ReactElement, useEffect, useRef, useState} from "react"
import {useSwipeable} from "react-swipeable"
import {Button} from "antd"
import {CloseOutlined} from "@ant-design/icons"
import {FeatureLike} from "ol/Feature"
import mapService from "@ui/services/MapService"
import FeatureService from "@ui/services/features/FeatureService"
import featuresPopupService from "@ui/services/features/PopupService"

enum PopupPosition {
  LEFT = "Left",
  RIGHT = "Right",
  UP = "Up",
  DOWN = "Down"
}
type TPopupPositions = `${PopupPosition}`

const Popup = (): ReactElement => {
  const popupElement = useRef<HTMLDivElement>(null)
  const popupCloseButton = useRef<HTMLButtonElement>(null)
  const [popupPosition, setPopupPosition] = useState<TPopupPositions>(PopupPosition.RIGHT)
  const handlersSwiping = useSwipeable({
    onSwiped: (event) => {
      event.dir === popupPosition
        ? popupCloseButton.current?.click()
        : setPopupPosition(event.dir)
    }
  })

  useEffect(() => {
    featuresPopupService.init(popupElement.current || undefined, handleShowPopup)
  }, [])

  const handleShowPopup = (feature: FeatureLike) => {
    const [width = 0, height = 0] = mapService.getMapSize() || []
    const coordinate = FeatureService.getFeatureCoordinates(feature)
    if (!coordinate) return
    const [x = 0, y = 0] = mapService.getPixelFromCoordinate(coordinate) || []
    const distances = [
      {direction: PopupPosition.LEFT, distance: x},
      {direction: PopupPosition.RIGHT, distance: width - x},
      {direction: PopupPosition.UP, distance: y},
      {direction: PopupPosition.DOWN, distance: height - y}
    ]

    const {width: popupWidth = 0, height: popupHeight = 0} = popupElement.current?.getBoundingClientRect() || {}

    const sorted = distances.sort(
      (a, b) => b.distance - a.distance)
    let direction = (sorted.find(dist => {
      return ([PopupPosition.UP, PopupPosition.DOWN].includes(dist.direction) && x > popupWidth / 2 && width - x > popupWidth / 2)
        || ([PopupPosition.LEFT, PopupPosition.RIGHT].includes(dist.direction) && y > popupHeight / 2 && height - y > popupHeight / 2)
    }) || sorted[0]).direction

    setPopupPosition(direction)
  }

  return (
    <div className={`popup position-${popupPosition.toLowerCase()}`} ref={popupElement}>
      <Button icon={<CloseOutlined/>} ref={popupCloseButton}/>
      <div className="popup-content" {...handlersSwiping}></div>
    </div>
  )
}

export default Popup
